import { useEffect } from 'react'
import { useSelector, shallowEqual } from 'react-redux'
import classNames from 'classnames'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { createUseStyles, useTheme } from 'react-jss'
import Loader from '@/components/Loader'
import Header from '@/components/Header'
import Overlay from '@/components/Overlay'
import Spinner from '@/components/Spinner'
import Nav from '@/components/Nav'
import Modal from '@/components/Modal'
import SVGSprite from '@/components/SVGSprite'
import constants from '@/constants'
import global from '@/global'
import devMode from '@/utils/devmode'

const useStyles = createUseStyles(global)

const Layout = ({ children }) => {
  const classes = useStyles()
  const theme = useTheme()

  const { headerNav, mainNav, extraNav, socialNav, languageNav, mediaQueryKey, strings } = useSelector((state) => ({
    mainNav: state.nav.main_menu,
    socialNav: state.nav.social_menu,
    extraNav: state.nav.extra_menu,
    headerNav: state.nav.header_menu,
    languageNav: state.nav.language_menu,
    strings: state.language.string,
    mediaQueryKey: state.mediaQuery.key,
  }), shallowEqual)

  const setProperty = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`)
    document.documentElement.style.setProperty('--vh-nav', `${window.innerHeight / 100}px`)
    theme.detect.vh = `${window.innerHeight / 100}px`
    window.vw = window.innerWidth
  }

  const events = () => {
    setProperty()
    if (theme.detect.hasTouch) {
      window.addEventListener('orientationchange', () => { setProperty() })
    }
    window.addEventListener('resize', () => {
      if (!theme.detect.isNativeScroll) setProperty()
      document.documentElement.style.setProperty('--vh-nav', `${window.innerHeight / 100}px`)
    })
  }

  useEffect(() => {
    events()
  }, [])

  return (
    <div
      className={classNames({
        [classes.root]: true,
        'content-root': true,
        touch: theme.detect.hasTouch,
        no_touch: !theme.detect.hasTouch,
      })}
    >
      <GoogleReCaptchaProvider reCaptchaKey={!devMode && constants.config.RECAPTCHA_SITE_KEY}>
        <Loader />
        <Modal />
        {mediaQueryKey > 1 && <Overlay />}
        <Spinner />
        <Nav
          mainNav={mainNav}
          extraNav={extraNav}
          socialNav={socialNav}
          languageNav={languageNav}
        />
        <Header headerNav={headerNav} />
        <div className="wrapper">
          {children}
        </div>
        <SVGSprite />
      </GoogleReCaptchaProvider>
    </div>
  )
}

export default Layout
